export const GOOD_REACTION = 'good';
export const FAIR_REACTION = 'fair';
export const EXCELLENT_REACTION = 'excellent';
